import { mapState, mapDispatch } from "./container"
import component from "./component"
import connector from "../../utils/reduxRouter/connector"

export default connector({
  mapState,
  mapDispatch,
  component,
})
